import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { Currency } from '@recruitee/pricing-types';
import type { BillingPlanTier } from '@recruitee/products-types';
import type { PaymentInterval } from '@recruitee/subscription-types';

import { PlanPickerProduct } from './plan-picker.types';

interface CommonProps {
  slotsLeft: number | undefined;
  assignedProductCode: BillingPlanTier | undefined;
  trialDaysLeft: number | undefined;
  trial: boolean;
  activePlanCode: BillingPlanTier;
  activePlanCustom: boolean;
  activePlanCurrency: Currency;
  activePlanPaymentInterval?: PaymentInterval;
  usedJobSlots: number;
  selfService: boolean;
}

@Injectable()
export class PlanPickerAnalytics extends AnalyticsBase {
  public readonly namespace = 'PlanPicker';
  public readonly requireViewContext = false;

  private commonProps: CommonProps;

  public trackChurn() {
    this.track('Churn');
  }

  public trackCurrencyChange(selectedCurrency: Currency) {
    this.track('SelectCurrency', {
      selectedCurrency,
    });
  }

  public trackPaymentIntervalSelect(selectedInterval: PaymentInterval) {
    this.track('PaymentIntervalSelect', {
      selectedInterval,
    });
  }

  public trackSlotsSelect(pickerProduct: PlanPickerProduct, selectedSlots: number) {
    this.track('SlotsSelect', {
      // adjustedPlanId: pickerProduct.product?.id,
      adjustedPlanCode: pickerProduct.codename,
      adjustedPlanSlots: selectedSlots,
      adjustedPlanCustom: pickerProduct.product?.custom,
    });
  }

  public trackSelectPlan(pickerProduct: PlanPickerProduct) {
    this.track('PlanSelect', {
      // selectedPlanId: pickerProduct.product?.id,
      selectedPlanCode: pickerProduct.codename,
      selectedPlanSlots: pickerProduct.state.selectedSlots,
      selectedPlanCustom: pickerProduct.product?.custom,
    });
  }

  public setCommonProps(commonProps: CommonProps) {
    this.commonProps = commonProps;
  }

  public track(name: string, props?: any) {
    const combinedProps = {
      ...(props || {}),
      ...this.commonProps,
    };

    super.track(name, combinedProps);
  }
}
